import { useMutation } from "react-query";
import {
  SharedLicensePlateRequestParams,
  insertSharedLicensePlate,
} from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const insertSharedLicensePlateFn = async (
  params: SharedLicensePlateRequestParams
) => {
  return await insertSharedLicensePlate(params);
};

export function useInsertSharedLicensePlate() {
  return useMutation(insertSharedLicensePlateFn, {
    mutationKey: MUTATION_KEYS.insertSharedLicensePlate,

    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
